<template lang="pug">
v-app
  section.position-relative
    header.d-flex.row.flex-row.align-items-end.mb-5
      .col
        router-link.button-previous.mr-2(to="/confirmacion-procesos/id")
          i.fas.fa-chevron-left
        h3.m-0.d-inline-block.align-middle
          i {{$route.name}}
        br
        div(v-for="usr in user.users")
          h1.d-inline-block.m-0.text-capitalize
            i {{usr.name}}
      .col
        .card.ad_border1-secondary.rounded-xl
          h4
            i Objetivos
              .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(objective, index) in user.objectives")
                form
                  .d-flex.row.form-group.align-items-end.mb-1
                    .col-10
                      label
                        a(:id="'viaje' + index")
                          i.icon-letters.icon-letters__viaje(v-if="objective.travel") V
                          i.icon-letters.icon-letters__producto.mx-1(v-if="objective.product") P
                          i.icon-letters.icon-letters__segmento(v-if="objective.segment") S
                        b-tooltip(:target="'viaje' + index" , placement='top')
                          | {{objective.travel ? objective.travel.name : ' '}} + {{objective.product ? objective.product.name : ' '}} + {{objective.segment ? objective.segment.name : ' '}}
                      label.ml-2
                        a(:id="'kpineg' + index")
                          i.icon-letters.icon-letters__negocio.mr-1 N
                        b-tooltip(:target="'kpineg' + index", placement="top")
                          | {{objective.business_type.name}}
                      label.ml-2
                        i.icon-letters.icon-letters__kpi.mr-1(v-if="objective.kpi") A
                        | {{ objective.open ? objective.business_type.name : objective.kpi.name }}
                    .col-1
                      label.ml-2
                        .col-auto.text-right.text-info
                          | {{ objective.open ? 'Libre' : ' ' }}

    section
      .d-flex.row
        .col-12
          .card.ad_border1-secondary.rounded-xl.mb-0.position-relative(:class="{'off-position' : !compromisocolab}")
            .row.d-flex.align-items-end
              .col
                h4.ad_text-primary.m-0
                  i Compromisos colaborador 
              .col-auto
                .row
                  .col
                    p.text-nowrap.ad_text-danger.font-italic.m-0
                      | Pendientes: {{ listUserCommitments.pendientes.length }}
                  .col
                    button.ad_text-primary.text-nowrap(@click="compromisocolab = !compromisocolab" :class="{'chevron-up' : !compromisocolab}")
                      span.text-bold.font-italic Ver 
                        em(v-if="!compromisocolab")  menos
                        em(v-if="compromisocolab")  más
                      i.fas.fa-chevron-down.ad_text-primary.ml-1
            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col-7
                input.form-control(v-model="commitment.description" type="text" placeholder="Descripción")
              .col.px-1.position-relative

                v-menu(ref='collabDate', v-model='collabDate', :close-on-content-click='false', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='commitment.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='commitment.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="addCommitmentToCollab()")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : compromisocolab}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listUserCommitments.pendientes == ''")
                    | Aún no tienes compromisos pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listUserCommitments.pendientes != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th(width="80") Sem
                        th(width="40")
                        th(width="100")
                    tbody
                      tr(v-for="pendiente in listUserCommitments.pendientes")
                        td
                          div.py-2
                            | {{ pendiente.description }}
                        td
                          div
                            | {{moment(pendiente.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendiente.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(pendiente.scheduled)")
                              | {{ moment().format("W") - moment(pendiente.scheduled).format("W") === 0 ? 1 : moment().format("W") - moment(pendiente.date).format("W") }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(pendiente.scheduled)")
                              | {{ moment().format("W") - moment(pendiente.scheduled).format("W")  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(pendiente.scheduled)")
                              | {{ moment().format("W") - moment(pendiente.scheduled).format("W") }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(pendiente._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(href="#" @click="openCloseModal(pendiente._id, 'collabCommitment')")
                              | Cerrar                      
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listUserCommitments.nuevos == ''")
                    | Aún no tienes compromisos nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listUserCommitments.nuevos != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th Sem.
                        th(width="80")
                        th(width="50")
                    tbody
                      tr(v-for="nuevo in listUserCommitments.nuevos")
                        td
                          div.py-2
                            | {{ nuevo.description }}
                        td
                          div
                            | {{moment(nuevo.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(nuevo.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success
                              |  1&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(nuevo._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeCommit('user', nuevo.id)")
                              i.fas.fa-times.rounded-circle.text-white     

        .col-12
          .card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !compromisolider}")
            .row.d-flex.align-items-end
              .col
                h4.ad_text-primary.m-0
                  i Compromisos Líder
              .col-auto
                .row
                  .col
                    p.text-nowrap.ad_text-danger.font-italic.m-0
                      | Pendientes: {{ listLeaderCommitments.pendientes.length}}
                  .col
                    button.ad_text-primary.text-nowrap(@click="compromisolider = !compromisolider" :class="{'chevron-up' : !compromisolider}")
                      span.text-bold.font-italic Ver 
                        em(v-if="!compromisolider")  menos
                        em(v-if="compromisolider")  más
                      i.fas.fa-chevron-down.ad_text-primary.ml-1
            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col-7
                input.form-control(v-model="leaderCommitment.description" type="text" placeholder="Descripción")
              .col.px-1.position-relative

                v-menu(ref='leaderDate', v-model='leaderDate', :close-on-content-click='false', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='leaderCommitment.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='leaderCommitment.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="addCommitmentToLeader()")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : compromisolider}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listLeaderCommitments.pendientes == ''")
                    | Aún no tienes compromisos pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listLeaderCommitments.pendientes != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th(width="80") Semana
                        th(width="40")
                        th(width="100")
                    tbody
                      tr(v-for="pendiente in listLeaderCommitments.pendientes")
                        td
                          div.py-2
                            | {{ pendiente.description }}
                        td
                          div
                            | {{moment(pendiente.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendiente.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(pendiente.scheduled)")
                              | {{ moment().format("W") - moment(pendiente.scheduled).format("W") === 0 ? 1 : moment().format("W") - moment(pendiente.date).format("W") }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(pendiente.scheduled)")
                              | {{ moment().format("W") - moment(pendiente.scheduled).format("W")  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(pendiente.scheduled)")
                              | {{ moment().format("W") - moment(pendiente.scheduled).format("W") }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(pendiente._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(href="#" @click="openCloseModal(pendiente._id, 'leaderCommitment')")
                              | Cerrar                      
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listLeaderCommitments.nuevos == ''")
                    | Aún no tienes compromisos nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listLeaderCommitments.nuevos != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th Sem.
                        th(width="80")
                        th(width="50")
                    tbody
                      tr(v-for="nuevo in listLeaderCommitments.nuevos")
                        td
                          div.py-2
                            | {{ nuevo.description }}
                        td
                          div
                            | {{moment(nuevo.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(nuevo.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success
                              |  1&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(nuevo._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeCommit('leader', nuevo.id)")
                              i.fas.fa-times.rounded-circle.text-white

        .col-12
          .card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !compromisoper}")
            .row.d-flex.align-items-end
              .col
                h4.ad_text-primary.m-0
                  i Objetivos de Desarrollo Personal
              .col-auto
                .row
                  .col
                    p.text-nowrap.ad_text-danger.font-italic.m-0
                      | Pendientes: {{ listPersonalCommitments.pendientes.length }}
                  .col
                    button.ad_text-primary.text-nowrap(@click="compromisoper = !compromisoper" :class="{'chevron-up' : !compromisoper}")
                      span.text-bold.font-italic Ver 
                        em(v-if="!compromisoper")  menos
                        em(v-if="compromisoper")  más
                      i.fas.fa-chevron-down.ad_text-primary.ml-1
            .row.d-flex.align-items-center.my-3
              .col-auto.pr-1
                label.m-0 Nuevo
              .col
                input.form-control(v-model="personalCommitment.description" type="text" placeholder="Descripción")
              .col
                .ad_select
                  select(v-model='personalCommitment.category', @change='getSubByCat($event)')
                    option(:value="null" disabled) Selecciona categoria
                    option(:value="category", v-for="category in categories", :key="category._id") {{category.name}}
              .col
                .ad_select
                  select(v-model='personalCommitment.subcategory', @change='')
                    option(:value="null" disabled) Selecciona sub categoria
                    option(:value="subcategory", v-for="subcategory in subcategories") {{subcategory.name}}
              .col-auto.ml-auto
                button.ad_bg-success.btn-icon(type="button", @click="addPersonalObjective(user.users[0].id)")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : compromisoper}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listPersonalCommitments.pendientes == ''")
                    | Aún no tienes Objetivos de Desarrollo Personal pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listPersonalCommitments.pendientes != ''")
                    thead
                      tr
                        th(width="40%") Objetivo
                        th Categoría
                        th Subcategoria
                        th Fecha de ingreso
                        th(width="80") Semana
                        th(width="40")
                        th(width="100")
                    tbody
                      tr(v-for="pendiente in listPersonalCommitments.pendientes")
                        td
                          div.py-2
                            | {{ pendiente.name }}
                        td
                          div
                            | {{ pendiente.category.name }}
                        td
                          div
                            | {{ pendiente.subcategory.name }}
                        td
                          div
                            | {{moment().utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(pendiente.creation_date)")
                              | {{ moment().format("W") - moment(pendiente.creation_date).format("W") === 0 ? 1 : moment().format("W") - moment(pendiente.date).format("W") }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(pendiente.creation_date)")
                              | {{ moment().format("W") - moment(pendiente.creation_date).format("W")  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(pendiente.creation_date)")
                              | {{ moment().format("W") - moment(pendiente.creation_date).format("W") }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(pendiente._id, 'personalCommitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(href="#" 
                            @click="openCloseModal(pendiente._id, 'personalCommitment')")
                              | Cerrar                      
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listPersonalCommitments.nuevos == ''")
                    | Aún no tienes Objetivos de Desarrollo Personal nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listPersonalCommitments.nuevos != ''")
                    thead
                      tr
                        th(width="40%") Objetivo
                        th Categoría
                        th Subcategoria
                        th(width="50")
                        th(width="50")
                    tbody
                      tr(v-for="nuevo in listPersonalCommitments.nuevos")
                        td
                          div.py-2
                            | {{ nuevo.name }}
                        td
                          div
                            | {{ nuevo.category.name }}
                        td
                          div
                            | {{ nuevo.subcategory.name }}
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(nuevo._id, 'personalCommitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removePersonalCommit(nuevo._id)")
                              i.fas.fa-times.rounded-circle.text-white     

        .col-12
          .card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !problemas}")
            .row.d-flex.align-items-end
              .col
                h4.ad_text-primary.m-0
                  i Problemas & Oportunidades 
              .col-auto
                button.ad_text-primary(@click="problemas = !problemas" :class="{'chevron-up' : !problemas}")
                  span.text-bold.font-italic Ver 
                    em(v-if="!problemas")  menos
                    em(v-if="problemas")  más
                  i.fas.fa-chevron-down.ad_text-primary.ml-1
            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col-7
                input.form-control(v-model="problemsAndOportunities.description" type="text" placeholder="Descripción")
              .col.px-1.position-relative

                v-menu(ref='probOportMenu', v-model='probOportMenu', :close-on-content-click='false', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='problemsAndOportunities.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='problemsAndOportunities.date', no-title='', scrollable='', locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")              
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="newProblem()")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : problemas}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listProblemsAndOport.pendientes == ''")
                    | Aún no tienes Problemas & Oportunidades pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listProblemsAndOport.pendientes != ''")
                    thead
                      tr
                        th Descripción
                        th Fecha de ingreso
                        th Semana
                        th(width="50")
                        th(width="80")
                    tbody
                      tr(v-for="op in listProblemsAndOport.pendientes")
                        td
                          div.py-2
                            | {{ op.description }}
                        td
                          div
                            | {{moment(op.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(op.date)")
                              | {{ moment().format("W") - moment(op.date).format("W") === 0 ? 1 : moment().format("W") - moment(op.date).format("W") }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(op.date)")
                              | {{ moment().format("W") - moment(op.date).format("W")  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(op.date)")
                              | {{ moment().format("W") - moment(op.date).format("W") }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(@click="openCloseModal(op._id, 'problem')")
                              | Cerrar
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listProblemsAndOport.nuevos == ''")
                    | Aún no tienes Problemas & Oportunidades nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listProblemsAndOport.nuevos != ''")
                    thead
                      tr
                        th Descripción
                        th Fecha de ingreso
                        th(width="50")
                        th(width="50")
                    tbody
                      tr(v-for="op in listProblemsAndOport.nuevos")
                        td
                          div.py-2
                            | {{ op.description }}
                        td
                          div
                            | {{moment(op.date).utc().format("DD/MM/YYYY")}}
                        td.text-right
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                              i.icono.icono-comentarios.ad_text-primary
                        td.text-right
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeProblem(op._id)")
                              i.fas.fa-times.rounded-circle.text-white
                      
      .d-flex.row.flex-row.mt-4
        .col-12.text-right
          button.btn.btn-primary.py-2.px-5(@click="closeCP()")
            em Finalizar_

  v-navigation-drawer(v-model='commenting', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Comentarios
    .col-12.mt-4
      .form-group.mt-4
        textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
      .form-group.justify-content-between
        button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="commenting = false")
          i.far.fa-times-circle.fa-1x.mr-1.align-bottom
          | Cancelar
        button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="createComment(comment)")
          | Agregar comentario
          i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom

      hr.my-4
    
      h3.ad_text-grayMedio.mb-3
        i Anteriores
      div(v-for="comment in comments")    
        .row.mb-3
          .col-4.pr-0
            p.font-weight-bold.m-0 {{ comment.user }}
            small.d-block {{ moment(comment.creation_date).utc().format("DD/MM/YYYY") }}
            small.d-block {{ moment(comment.creation_date).utc().format('LT') }}
          .col-8.pl-0
            .dialog-box 
              p {{ comment.description }} 
  
  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Cerrar Compromiso Colaborador
    section.py-4.px-2.overflowy-auto
      .col.d-flex.flex-nowrap
        p Descripción del compromiso acordado
      .d-flex.flex-row
        .col.d-flex.flex-nowrap
          a#provisioncerrar
            i.icon-letters.icon-letters__viaje.mr-1 V
          b-tooltip(target="provisioncerrar" , placement='top')
            | Provisión-Telco-Personas
          a#kpicerrar.ml-2
            i.icon-letters.icon-letters__kpi.mr-1 A
          b-tooltip(target="kpicerrar" , placement='top')
            | Satisfaccion Neta Gral Provision
          p KPI Adherencia
        .col-5
            c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
            c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="closeItem()")
            | Cerrar compromisos
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
        
        hr.my-4
      
        h3.ad_text-grayMedio.mb-3
          i Anteriores
        div(v-for="comment in comments")    
          .row.mb-3
            .col-4.pr-0
              p.font-weight-bold.m-0 {{ comment.user }}
              small.d-block {{ moment(comment.creation_date).utc().format("DD/MM/YYYY") }}
              small.d-block {{ moment(comment.creation_date).utc().format('LT') }}
            .col-8.pl-0
              .dialog-box 
                p {{ comment.description }} 

</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment-timezone'
import Flatpickr from 'vendors/cover/vendors/flatpickr'
import { mapActions } from 'vuex'

export default {

  name: 'ConfirmacionProcesosEjecutar',
  components: {
     Multiselect,
     Flatpickr
  },
  data () {
    return {
      cumplimiento: '',
      drawer: null,
      collabDate: false,
      leaderDate: false,
      personalDate: false,
      probOportMenu: false,
      commenting: null,
      date: null,
      user: { S: {}, P: {} },
      team: [],
      accountable: null,
      commitment: {},
      leaderCommitment: {},
      personalCommitment: {},
      problemsAndOportunities: {},
      commitments: [],
      pcommitments: [],
      objectives: [],
      tracing: null,
      listUserCommitments: { nuevos: [], pendientes: [] },
      listLeaderCommitments: { nuevos: [], pendientes: [] },
      listPersonalCommitments: { nuevos: [], pendientes: [] },
      listProblemsAndOport: { nuevos: [], pendientes: [] },
      compromisocolab: false,
      compromisolider: false,
      compromisoper: false,
      problemas: false,
      otros: false,
      comment: null  ,
      categories: [],
      subcategories: [], 
      type: null,
      comments: [],
      closing: null
    }
  },
  methods: {
    moment,
    ...mapActions('tracing', [
      'createProblemOrOportunity', 
      'getUserInformation', 
      'loadCommitmentsByUser', 
      'getPersonalCommitments', 
      'listProblems', 
      'deleteProblem',
      'finishTracing'
    ]),
    ...mapActions('commitment', [
      'addCommitmentToTracing', 
      'deleteCommitment', 
      'addCommentToCommitment', 
      'getCommentsFromCommitment',
      'closeCommitment'
    ]),
    ...mapActions('personalcommitments', [
      'createPC', 
      'deletePersonalCommitment', 
      'addCommentToPersonalCommitment', 
      'getCommentsFromPersonalCommitment',
      'closePersonalCommitment'
    ]),
    ...mapActions('category', [ 'categoriesList' ]),
    ...mapActions('subcategory', [ 'byCategoryId' ]),
    ...mapActions('problem', [
      'addCommentToProblem', 
      'getCommentsFromProblem',
      'closeProblem'
    ]),
    getUser(id) {
    const vm = this;
      vm.getUserInformation(id).then(user => {
        vm.user = user
        const loadData = { 
          userId: vm.user.users[0].id, 
          tracingId: id, 
          userLeader: vm.$store.state.auth.user.id
        }
        vm.loadCommitments(loadData)
      })
    },
    addCommitmentToCollab() {
      const vm = this;
      const { team } = vm.$store.state.auth.user
      const { description, date } = vm.commitment
      const data = { 
        tracing: vm.$route.params.id,
        date: new Date(moment()),
        commitment: {
          scheduled: date,
          description,
          accountable: vm.user.users[0]._id,
        }
      }
      if (description && date) {
        vm.addCommitmentToTracing(data).then(response => {
          if (response.success) {
            const loading = vm.$toast.loading('Agregando compromiso de colaborador...')
            vm.commitment.description = ''
            vm.commitment.date = ''
            vm.listUserCommitments.nuevos.push(response.message)
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso de colaborador creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
         vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    addCommitmentToLeader() {
      const vm = this;
      const { id, team } = vm.$store.state.auth.user
      const { description, date } = vm.leaderCommitment
      const data = { 
        tracing: vm.$route.params.id,
        date: new Date(moment()),
        commitment: {
          scheduled: date,
          description,
          accountable: id,
        }
      }
      if (description && date) {
        vm.addCommitmentToTracing(data).then(response => {
          const loading = vm.$toast.loading('Agregando compromiso de lider...')
          if (response.success) {
            vm.leaderCommitment.description = ''
            vm.leaderCommitment.date = ''
            vm.listLeaderCommitments.nuevos.push(response.message)
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso de lider creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
         vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    loadCommitments(data) {
      const vm = this
      vm.loadCommitmentsByUser(data)
      .then(commitments => {
        vm.listUserCommitments.nuevos = commitments.nuevos.filter(commitment => {
          return commitment.user._id == vm.user.users[0].id
        })
        vm.listUserCommitments.pendientes = commitments.pendientes.filter(commitment => {
          return commitment.user._id == vm.user.users[0].id
        })
      })
      vm.getPersonalCommitments(data)
      .then(personal => {
        vm.listPersonalCommitments = personal.commitments
      })
      data.type = 'all'
      vm.listProblems(data).then(problems => {
        vm.listProblemsAndOport = problems
      })
      vm.loadCommitmentsByUser(data)
      .then(commitments => {
        vm.listLeaderCommitments.nuevos = commitments.nuevos.filter(commitment => {
          return commitment.user._id == vm.$store.state.auth.user.id
        })
        vm.listLeaderCommitments.pendientes = commitments.pendientes.filter(commitment => {
          return commitment.user._id == vm.$store.state.auth.user.id
        })  
      })
    },
    addPersonalObjective(user) {
      const vm = this;
      if (vm.personalCommitment.description && vm.personalCommitment.category && vm.personalCommitment.subcategory) {
        const data = {
          name: vm.personalCommitment.description,
          category: vm.personalCommitment.category._id,
          subcategory: vm.personalCommitment.subcategory.id,
          user,
          execute: true,
          tracing: vm.$route.params.id
        }
        vm.createPC(data).then(response => {
          const loading = vm.$toast.loading('Agregando objetivo de desarrollo personal...')
          if (response._id) {
            vm.personalCommitment.description = ''
            vm.personalCommitment.category = ''
            vm.personalCommitment.subcategory = ''
            vm.listPersonalCommitments.nuevos.push(response)
            loading.hide()
            vm.personalCommitment.description = ''
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso personal creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    getSubByCat() {
      const vm = this
      console.info(vm.personalCommitment.category)
      vm.byCategoryId(vm.personalCommitment.category._id).then(() => {
        vm.subcategories = vm.$store.getters['subcategory/getSubcategories']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    newProblem() {
      const vm = this;
      if (vm.problemsAndOportunities.description && vm.problemsAndOportunities.date) {
        const data = {
          user: vm.user.users[0].id,
          tracing: vm.$route.params.id,
          description: vm.problemsAndOportunities.description,
          date: vm.problemsAndOportunities.date,
          type: 'all'
        }
        vm.createProblemOrOportunity(data).then(result => {
          const loading = vm.$toast.loading('Agregando objetivo de desarrollo personal...')
          if (result._id) {
            vm.listProblemsAndOport.nuevos.push(result)
            vm.problemsAndOportunities.description = ''
            vm.problemsAndOportunities.date = ''
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Nuevo problema/oportunidad creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    removeCommit(type, id) {
      const vm = this;
      if (type === 'user') {
        vm.deleteCommitment(id).then(result => {
          if (result) {
            vm.listUserCommitments.nuevos = vm.listUserCommitments.nuevos.filter(commitment => {
              return commitment.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })      
      } else {
        vm.deleteCommitment(id).then(result => {
          if (result) {
            vm.listLeaderCommitments.nuevos = vm.listLeaderCommitments.nuevos.filter(commitment => {
              return commitment.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      }
    },
    removePersonalCommit(id) {
      const vm = this;
      vm.deletePersonalCommitment(id).then(result => {
        if (result) {
          vm.listPersonalCommitments.nuevos = vm.listPersonalCommitments.nuevos.filter(commitment => {
            return commitment._id !== id
          })
          vm.$notify({
            type: 'success',
            title: 'Notificación',
              content: 'Compromiso personal eliminado',
            closeable: true,
            duration: 5000
          })
        }
      })
    },
    removeProblem(id) {
      const vm = this;
      vm.deleteProblem(id).then(result => {
        if (result) {
          vm.listProblemsAndOport.nuevos = vm.listProblemsAndOport.nuevos.filter(problem => {
            return problem._id !== id
          })
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Problema/oportunidad eliminado',
            closeable: true,
            duration: 5000
          })
        }
      })
    },
    closeCP() {
      const vm = this;
      const data = {
        tracingId: vm.$route.params.id,
        userId: vm.user.users[0]._id,
        userLeader: vm.$store.state.auth.user.id
      }
      vm.finishTracing(data).then(result => {
        const loading = vm.$toast.loading('Cerrando confirmacion de proceso...')
        if (result.success) {
          setTimeout(() => {
            this.$router.push('/confirmacion-procesos/id')
            loading.hide()
          }, 3000)
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Confirmacion de proceso cerrado',
            closeable: true,
            duration: 5000
          })
        }
      }).catch(e => {
        loading.hide()
        vm.$notify({  
          type: 'error',
          title: 'Error',
          content: 'Error al cerrar confirmacion de proceso',
          closeable: true,
          duration: 5000
        })        
      })
    },
    getComments(id, type) {
      const vm = this
      vm.commenting = id
      vm.type = type
      switch (vm.type) {
        case 'commitment':
          vm.getCommentsFromCommitment(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'personalCommitment':
          vm.getCommentsFromPersonalCommitment(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'problem':
          vm.getCommentsFromProblem(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
      }
    },
    createComment(comment) {
      const vm = this
      const data = {
        description: comment,
        _id: vm.commenting,
        user: vm.$store.state.auth.user.name
      }
      switch (vm.type) {
        case 'commitment':
          vm.addCommentToCommitment(data).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'personalCommitment':
          vm.addCommentToPersonalCommitment(data).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'problem':
          vm.addCommentToProblem(data).then(response => {
            vm.comments = response.reverse()
          })
        break
      }
      vm.comment = ''
    },
    openCloseModal(id, type) {
      const vm = this;
      vm.drawer = true
      vm.closing = id
      vm.type = type;
    },
    closeItem() {
      const vm = this;
      if (vm.cumplimiento === '') {
        vm.$notify({  
          type: 'danger',
          title: 'Error',
          content: 'Tiene que elegir si fue completado',
          closeable: true,
          duration: 5000
        })  
      } else {      
        const data = {
          accomplished: vm.cumplimiento,
          id: vm.closing,
        }
        switch (vm.type) {
          case 'collabCommitment':
            vm.closeCommitment(data).then(result => {
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de compromiso ejecutado',
                  closeable: true,
                  duration: 5000
                })  
              vm.listUserCommitments.pendientes = vm.listUserCommitments.pendientes.filter(commitment => {
                return commitment._id !== result._id
              })
              }
            })
            break
          case 'leaderCommitment':
            vm.closeCommitment(data).then(result => {
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de compromiso ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                vm.listLeaderCommitments.pendientes = vm.listLeaderCommitments.pendientes.filter(commitment => {
                  return commitment._id !== result._id
                })
              }
            })
            break
          case 'personalCommitment':
            vm.closePersonalCommitment(data).then(result => {
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de objetivo de desarrollo personal ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                vm.listPersonalCommitments.pendientes = vm.listPersonalCommitments.pendientes.filter(commitment => {
                  return commitment._id !== result._id
                })
              }
            })
            break
          case 'problem':
            vm.closeProblem(data).then(result => { 
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de problema ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                vm.listProblemsAndOport.pendientes = vm.listProblemsAndOport.pendientes.filter(problem => {
                  return problem._id !== result._id
                })
              }
            })
            break
        }
        vm.drawer = false
        vm.cumplimiento = ''
      }
    }
  },
  watch: {
    drawer : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')
      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
  },
  mounted() {
    const vm = this; 
    const tracingId = vm.$route.params.id
    vm.getUser(tracingId)
    vm.categoriesList().then(() => {
      vm.categories = vm.$store.getters['category/getCategories']
    }, (error) => {
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })
  }
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/confirmacion-procesos-ejecutar.vue